import { getOperationalInstalledApps, getSuitestreamLauncherApp } from '../../components/Remote/installedAppSelection';

export async function loadLauncherDeviceInventory(route, { getTarget, getLinks, getAssigned }) {
  const [profile, links, assigned] = await Promise.allSettled([
    getTarget(route.target.id, { includeApps: true }),
    getLinks(route.target.id),
    getAssigned ? getAssigned(route.target.id) : Promise.resolve({ destinations: [] }),
  ]);
  const target = profile.status === 'fulfilled' ? profile.value?.target : null;
  const installedApps = target?.installedApps || [];
  return {
    ...route,
    assignedDestinations: assigned.status === 'fulfilled' ? (assigned.value?.destinations || []).filter((entry) =>
      (Number(entry.screenId) || null) === (Number(route.screen?.id) || null)) : [],
    assignedError: assigned.status === 'rejected' ? 'Assigned apps could not be loaded. Refresh to retry.' : '',
    appsStatus: profile.status === 'fulfilled' ? 'ready' : 'error',
    appsMessage: profile.status === 'rejected' ? profile.reason?.message || 'Could not load installed apps.' : '',
    switchReady: route.switchReady && profile.status === 'fulfilled',
    appControlDeviceId: target?.appControlDeviceId || null,
    apps: getOperationalInstalledApps(installedApps),
    suitestreamApp: getSuitestreamLauncherApp(installedApps, { registeredPlayer: Boolean(target?.appControlDeviceId) }),
    links: links.status === 'fulfilled' ? links.value?.contentTargets || [] : [],
  };
}
